import { Alert, Box, Button, Typography } from "@mui/material";
import { Contact } from "../../../types/Contact";
import React from "react";

import DownloadIcon from '@mui/icons-material/Download';

function CvTab({
    contact,
}: {
    contact: Contact;
}) {
    const relativeUrl = `/api/applications/${contact.id}/cv?embed=true`;
    const currentHostAndScheme = `${window.location.protocol}//${window.location.host}`;
    const absoluteUrl = `${currentHostAndScheme}${relativeUrl}`;
    const absoluteUrlUrlEcncoded = encodeURIComponent(absoluteUrl);

    return <Box sx={{ p: 2 }}>
        {contact.cv && contact.cv.length > 0 ?
            <>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mb: 2 }}>
                    <Button variant="outlined" startIcon={<DownloadIcon />} href={`/api/applications/${contact.id}/cv`}>
                        <Typography sx={{ mr: 2 }}>Télécharger le CV du candidat</Typography>
                        <img src={`/assets/img/cmn/icons/${contact.cv.endsWith(".pdf") ? "pdf" : "word"}-16x16.png`} width="16" height="16" alt="Télécharger le CV" />
                    </Button>
                </Box>
                {contact.cv.endsWith(".pdf") &&
                    <embed src={relativeUrl} type="application/pdf" width="100%" height="600px" />
                }
                {(contact.cv.endsWith(".docx") || contact.cv.endsWith(".doc")) && 
                <iframe 
                    title={`CV ${contact.firstname} ${contact.lastname}`} 
                    width="100%"
                    height="600px"
                    src={`https://docs.google.com/gview?url=${absoluteUrlUrlEcncoded}&embedded=true`}>
                </iframe>}
            </>
            :
            <Alert severity="info">Le candidat n'a pas encore soumis de CV.</Alert>
        }
    </Box>;
}

export default React.memo(CvTab, (prevProps, nextProps) => {
    return prevProps.contact.id === nextProps.contact.id;
});